import React from 'react';
import './App.css';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Home from './pages/Home.jsx';
import Appoint from './pages/Appointment.jsx';
import Classes from './pages/Classes.jsx';
import NotFound from './pages/NotFound.jsx';
import TagManager from 'react-gtm-module';

const tagManagerArgs = {
  gtmId: 'G-HEYHBPLSDD',
};

TagManager.initialize(tagManagerArgs);

const router = createBrowserRouter([
  { path: '/', element: <Home /> },
  { path: '/appointment', element: <Appoint /> },
  { path: '/classes', element: <Classes /> },
  { path: '*', element: <NotFound /> }
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
